export const ANALYTICS_WINDOW_KEYS = ["7d", "30d", "all"];

export function analyticsWindowOptions(activeSubscription) {
  return activeSubscription ? ANALYTICS_WINDOW_KEYS : ["7d", "30d"];
}

export function analyticsWindowLabelKey(windowKey) {
  return `credits_window_${windowKey}`;
}

export function normalizeAnalyticsWindow(windowKey, activeSubscription) {
  const options = analyticsWindowOptions(activeSubscription);
  return options.includes(windowKey) ? windowKey : "30d";
}
